"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const utils_1 = require("../utils");
/**
 * We mostly use this event for changing status of order and order items to MERGED
 * @param event
 * @param prevState
 */
function default_1(event, prevState = {}) {
    const order = prevState;
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    (0, utils_1.updateOrderAndItemsStatus)(order, domain_1.OrderStatus.MERGED, domain_1.OrderItemStatus.MERGED);
    return order;
}
exports.default = default_1;
//# sourceMappingURL=orderMerged.js.map